import React from "react";
import { Booking } from "../../declarations/booking";
import { Menu, MenuItem } from "@mui/material";
import { MdMoreVert } from "react-icons/md";

interface BookingCardProps {
  booking: Booking;
  handleDeclineClickMui: (id?: string) => void;
  handleViewClickMui: (id?: string) => void;
  handleMenuOpen: (
    event: React.MouseEvent<HTMLButtonElement>,
    index: number
  ) => void;
  handleMenuClose: () => void;
  menuIndex: number | null;
  index: number;
  anchorEl: HTMLElement | null;
}

const BookingCard: React.FC<BookingCardProps> = ({
  booking,
  handleDeclineClickMui,
  handleViewClickMui,
  handleMenuOpen,
  handleMenuClose,
  menuIndex,
  index,
  anchorEl,
}) => {
  return (
    <div className="rounded-lg p-4 shadow-sm relative bg-white border border-gray-300">
      {/* Booking Details */}
      <div className="flex flex-wrap items-start justify-between gap-4">
        {/* Package Name */}
        <div className="min-w-[140px] flex-1 sm:flex-none">
          <p className="text-sm text-gray-500 mb-1">Package name</p>
          <p className="font-semibold">{booking.package?.title}</p>
        </div>

        {/* Booked By */}
        <div className="min-w-[140px] flex-1 sm:flex-none">
          <p className="text-sm text-gray-500 mb-1">Booked by</p>
          <p className="font-semibold">
            {booking.bookedBy?.firstName} {booking.bookedBy?.lastName}
          </p>
        </div>

        {/* Package Owner */}
        <div className="min-w-[140px] flex-1 sm:flex-none">
          <p className="text-sm text-gray-500 mb-1">Package owner</p>
          <p className="font-semibold">
            {booking.packageOwner?.firstName} {booking.packageOwner?.lastName}
          </p>
        </div>

        {/* Adults & Infants */}
        <div className="min-w-[140px] flex flex-col gap-2 flex-1 sm:flex-none">
          <div>
            <p className="text-sm text-gray-500 mb-1">Total Adults</p>
            <p className="font-semibold">{booking.totalAdults}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500 mb-1">Total Infants</p>
            <p className="font-semibold">{booking.totalInfants}</p>
          </div>
        </div>

        {/* Payment Time */}
        <div className="min-w-[140px] flex-1 sm:flex-none">
          <p className="text-sm text-gray-500 mb-1">Payment Time</p>
          <p className="font-semibold">
            {booking.paymentTime === "pay_now"
              ? "Pay Now"
              : booking.paymentTime}
          </p>
        </div>

        {/* Calculated Amount */}
        <div className="min-w-[140px] flex-1 sm:flex-none">
          <p className="text-sm text-gray-500 mb-1">Calculated Amount</p>
          <p className="font-semibold">{booking.calculatedAmount}</p>
        </div>

        {/* Marked up Amount */}
        <div className="min-w-[140px] flex-1 sm:flex-none">
          <p className="text-sm text-gray-500 mb-1">Marked up Amount</p>
          <p className="font-semibold">{booking.markedUpAmount}</p>
        </div>

        {/* Status */}
        <div className="min-w-[100px] flex-1 sm:flex-none">
          <p className="text-sm text-gray-500 mb-1">Status</p>
          <span
            className={`bg-yellow-100 ${
              booking.status === "pending"
                ? "bg-yellow-100 text-yellow-600"
                : booking.status === "approved"
                ? "bg-green-100 text-green-600"
                : booking.status === "declined"
                ? "bg-red-100 text-red-600"
                : ""
            } text-xs px-2 py-1 rounded capitalize`}
          >
            {booking.status}
          </span>
        </div>

        {/* Three Dot Action */}
        <div className="relative min-w-[40px]">
          <button onClick={(e) => handleMenuOpen(e, index)}>
            <MdMoreVert />
          </button>
          <Menu
            anchorEl={anchorEl}
            open={menuIndex === index}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            PaperProps={{
              style: {
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                width: "112px",
              },
            }}
          >
            <MenuItem onClick={() => handleViewClickMui(booking._id)}>
              View
            </MenuItem>
            <MenuItem
              onClick={() => handleDeclineClickMui(booking._id)}
              style={{ color: "red" }}
            >
              Cancel
            </MenuItem>
          </Menu>
        </div>
      </div>
    </div>
  );
};

export default BookingCard;
